import { createUseStyles } from 'react-jss'

export const BAR_TOTAL_HEIGHT = 70

export const style = {
  legend: {
    marginBottom: 24
  }
}

export const useStyles = createUseStyles(style)
